import React, { useEffect, useState } from 'react';
import Widget from '../../../components/Widget';
import FuelConsumptionBarLineChart from '../../../components/Chart/FuelConsumptionBarLine';
import PeriodSelector from './PeriodSelector';

function FuelConsumptionDetails(props) {

    return (
        <Widget>
            {/* <PeriodSelector handleDataGroup={props.handleDataGroup} selectedGroup={props.selectedGroup} handlePeriodChange={props.handlePeriodChange} selectedValue={props.selectedValue}
                callFuelData={props.callFuelData} device={props.device} loading={props.loading} hasFuelSensor={props.hasFuelSensor} /> */}
            <FuelConsumptionBarLineChart assetData={props.assetData} data={props.data} selectedGroup={props.selectedGroup} loading={props.loading} />
        </Widget>
    );
}

export default FuelConsumptionDetails;
